module.exports = __webpack_public_path__ + "img/fm_workflow_1.d1dd6447.png";